import React from "react";
import { useTheme } from "../../context/useThemeContext";
import "./empty-table.css";

// Empty table component props interface
export interface EmptyTableProps {
  message?: string;
}

const EmptyTable: React.FC<EmptyTableProps> = ({
  message = "Нет данных для отображения",
}) => {
  const { isDarkMode } = useTheme();

  return (
    <div className="empty-table">
      <div className="empty-table__content">
        <div className="empty-table__icon">
          <img
            src={
              isDarkMode
                ? "/images/empty-folder-light.png"
                : "/images/empty-folder.png"
            }
            alt="Empty Folder"
            width={120}
            height={120}
          />
        </div>
        <div className="empty-table__message">
          <p>{message}</p>
        </div>
      </div>
    </div>
  );
};

export default EmptyTable;
